module.exports = __webpack_public_path__ + "static/media/surat_pernyataan_kesanggupan_bpjs.be89fb17.jpg";